import {APPLY_PROMOCODE_SUCCESS, SEND_ORDER_SUCCESS} from 'new-constants/api.constants';
import {STRIPE_SUCCESS, VIPPS_SUCCESS} from 'new-constants/payment.constants';
import {DONE_INCOMPATIBLE_CART_CONFIRMATION} from 'new-constants/popup.constants';
import {PromocodeState} from './promocode.reducer.types';
import {
    CHECK_ADYEN_PAYMENT_SUCCESS,
    CHECK_PAYMENT_STATUS_SUCCESS,
    ORDER_SUCCESS,
    SUBMIT_APPLE_PAY_SUCCESS,
    SUBMIT_GOOGLE_PAY_SUCCESS
} from '../constants/api.constants';
import {PaymentStatuses} from "../constants/common.constants";
import {ADYEN_SUCCESS} from '../constants/payment.constants';

export const defaultPromocodeCacheEntry = [];

const initialState: PromocodeState = {
	cache: {},
};

export const promocodeReducer = (previousState = initialState, action): PromocodeState => {
	switch (action && action.type) {
		case APPLY_PROMOCODE_SUCCESS:
			return {
				...previousState,
				cache: {
					...previousState.cache,
					[action.payload.restaurantId]: [
						...(previousState.cache[action.payload.restaurantId] || defaultPromocodeCacheEntry),
						action.payload.promocode,
					],
				},
			};
			break;

		case SEND_ORDER_SUCCESS:
			if (action.payload.isOrderSent) {
				return {
					...previousState,
					cache: {
						...previousState.cache,
						[action.payload.data.order.restaurantId]: defaultPromocodeCacheEntry,
					},
				};
			}

			return previousState;
			break;

		case STRIPE_SUCCESS:
		case VIPPS_SUCCESS:
			return {
				...previousState,
				cache: {
					...previousState.cache,
					[action.restaurantId]: defaultPromocodeCacheEntry,
				},
			};
			break;

		case ADYEN_SUCCESS:
			if (action.payload.action.type === 'redirect' || action.payload.action.type === 'threeDS2' || action.payload.action.type === 'swish') {
				return {
					...previousState,
				}
			}
			return {
				...previousState,
				cache: {
					...previousState.cache,
					[action.payload.restaurantId]: defaultPromocodeCacheEntry,
				},
			};
			break;

        case SUBMIT_GOOGLE_PAY_SUCCESS:
        case SUBMIT_APPLE_PAY_SUCCESS:
			if (action.payload.action.type === 'redirect' || action.payload.action.type === 'threeDS2') {
                return {
                    ...previousState,
                }
            }
            return {
                ...previousState,
                cache: {
                    ...previousState.cache,
                    [action.payload.restaurantId]: defaultPromocodeCacheEntry,
                },
            };
            break;

		case CHECK_PAYMENT_STATUS_SUCCESS:
			if(!(action.payload.isAdyenOrder && action.payload.data.status === PaymentStatuses.complete)) {
				return previousState;
			}

			return {
				...previousState,
				cache: {
					...previousState.cache,
					[action.payload.currentRestaurantId]: defaultPromocodeCacheEntry,
				},
			};
			break;

		case CHECK_ADYEN_PAYMENT_SUCCESS:
			if(action.payload.data.resultCode !== PaymentStatuses.authorised) {
				return previousState;
			}

			return {
				...previousState,
				cache: {
					...previousState.cache,
					[action.payload.currentRestaurantId]: defaultPromocodeCacheEntry,
				},
			};
			break;

		case ORDER_SUCCESS:
			if (!(action.payload.isScheduledForCancel && action.payload.data.order.isPaid)) {
				return previousState;
			}

			return {
				...previousState,
				cache: {
					...previousState.cache,
					[action.payload.data.order.restaurantId]: defaultPromocodeCacheEntry,
				},
			};
			break;

		case DONE_INCOMPATIBLE_CART_CONFIRMATION:
			return {
				...previousState,
				cache: {
					...previousState.cache,
					[action.restaurantId]: defaultPromocodeCacheEntry,
				},
			};
			break;

		default:
			return previousState;
	}
};
